import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const FORM_ENDPOINT = process.env.REACT_APP_FORM_ENDPOINT;

export const submitInquiry = (data) =>
  FORM_ENDPOINT
    ? axios.post(FORM_ENDPOINT, { form_type: "inquiry", website: "", ...data })
    : axios.post(`${API}/inquiries`, data);

export const submitPricingRequest = (data) =>
  FORM_ENDPOINT
    ? axios.post(FORM_ENDPOINT, { form_type: "pricing", website: "", ...data })
    : axios.post(`${API}/pricing-requests`, data);

export const submitManufacturerInquiry = (data) =>
  FORM_ENDPOINT
    ? axios.post(FORM_ENDPOINT, { form_type: "manufacturer", website: "", ...data })
    : axios.post(`${API}/manufacturer-inquiries`, data);
